<template>
    <v-expand-transition>
        <div v-if="isVisible">

            <!-- Editable Versions -->
            <component v-if="!schema._root || !schema._root.readOnly || schema.type == 'Group' || schema.type == 'Section Heading'"
                :is="controlName"
                :schema="mergedSchema"
                :value="value"
                @change="$emit('change', $event)"
            />

            <!-- Read Only Versions -->
            <template v-else>
                <FileView v-if="schema.type == 'File' "
                    :schema="mergedSchema"
                    :value="value"
                />

                <div v-else>
                    <template v-if="value">
                        <div class="element-label">
                            {{mergedSchema.label}}
                        </div>
                        <div class="mb-3" v-html="value">
                            
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </v-expand-transition>

</template>

<script>
import GroupControl from './controls/GroupControl'
import SectionControl from './controls/SectionControl'

import TextControl from './controls/TextControl'
import PaymentControl from './controls/PaymentControl'
import NumberControl from './controls/NumberControl'
import LinkControl from './controls/LinkControl'
import SwitchControl from './controls/SwitchControl'
import CheckboxControl from './controls/CheckboxControl'
import FileControl from './controls/FileControl'
import RadioControl from './controls/RadioControl'
import SectionHeadingControl from './controls/SectionHeadingControl'
import HtmlControl from './controls/HtmlControl'
import CurrencyControl from './controls/CurrencyControl'
import YesNoControl from './controls/YesNoControl'

import FileView from './viewers/FileView'
import MergeHelpers from '../helpers/MergeHelpers'


export default {

    data() {
        return {
        
        }
    },

    components: {
        TextControl, NumberControl, GroupControl, SectionControl, SwitchControl, CheckboxControl, 
        FileControl, LinkControl, RadioControl, PaymentControl,
        FileView, SectionHeadingControl, HtmlControl, CurrencyControl, YesNoControl,
    },
    
    props: {
        schema: Object,
        value: [Boolean, Array, String, Number, Object],
        context: Object,
        record: Object,
    },

    computed: {
        controlName() {
            return this.schema.type.replace(' ', '')  + 'Control'
        },
        viewerName() {
            return this.schema.type.replace(' ', '')  + 'View'
        },

        isVisible() {

            const visible = this.schema.visible

            if(typeof visible == 'undefined')
                return true
            if(typeof visible == 'boolean')
                return visible

            const expression = this.merge(visible, this.record)
            console.log('Expression is ', expression)
            let result
            try {
                result = eval(expression)
            } catch (e) {
                result = false
            }

            console.log('checking vis for ', this.schema.label, 'returns....', result)

            return result

        },

        mergedSchema() {
            const newSchema = {...this.schema}
            newSchema.label = this.merge(newSchema.label, this.record)
            return newSchema
        }
    },

    methods: {

        //keep these in case we need them
        evalInFormOrRecord(expression) {
            let ctx
            if(expression.indexOf('record.') > -1) {
                expression = expression.replace('record.', 'this.')
                ctx = this.record
            }
            else if(expression.indexOf('form.') > -1){
                
                expression = expression.replace('form.', 'this.')
                ctx = this.globalForm.formValue
            }

            return this.evalInContext(expression, ctx)
        },

        evalInContext(js, context) {
            
            //# Return the results of the in-line anonymous function we .call with the passed context
            return function() { return eval(js); }.call(context);
        },

        merge(str, context) {
            
            if(!str || str.indexOf('[') < 0)
                return str

            const mergeItems = this.findMergeFields(str)
            
            mergeItems.forEach(mergeItem => {
                const value = context[mergeItem.name]
                if(typeof value !== 'undefined')
                    str = str.replace(mergeItem.text, value)
                
            })
            // for(let name in context) {
            //     const mergeField = '[' + name + ']'
            //     console.log('Checking mergefield: ' + mergeField)
            //     if(str.indexOf(mergeField > -1)) { //exists in string
            //         const value = context[name]
            //         if(typeof value !== 'undefined')
            //             str = str.replace(mergeField, context[name])
            //     }
            // }
            console.log('Merge returns ', str)
            return str            
        },

        findMergeFields(searchString) {

            //console.log('findMegeFields', searchString)
            
            let matches = []
            let match
            
            do {
                match = String(searchString).match(/\[(.*?)\]/i)
                if(!match) 
                    break

                let innerMatch = match[1]
                let outerMatch = match[0]

                const innerArr = innerMatch.split('|')
                const matchObj = {
                    name: innerArr[0].trim(),
                    text: outerMatch, 
                    operations: []
                }
                for(let n = 1; n < innerArr.length; n++) {
                    const operationArr = innerArr[n].split(':')
                    matchObj.operations.push({
                        operator: operationArr[0].trim(),
                        value: (operationArr.length > 1 ? operationArr[1] : '').trim()
                    })
                }

                matches.push(matchObj)
                searchString = searchString.replace(outerMatch, '')

            } while(match)

            return (matches)
        }
    },

    created() {

    },

    watch: {
        'globalForm': {
            handler: function(newVal) {
                'Global form changed to ', newVal
            },
            deep: true,
        }
       
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// DynamicControl.vue?a62522fc